<template>
  <v-row
    class="flex-column"
    no-gutters
  >
    <v-col>
      <v-img
        :src="image"
        :max-height="imageHeight"
      />
    </v-col>
    <v-spacer />
    <v-col>
      <v-row
        class="justify-center"
        no-gutters
      >
        <v-col
          lg="10"
          xl="10"
        >
          <slot />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GenericPage",
  props: {
    image: {
      type: String,
      default: ""
    },
    imageHeight: {
      type: String,
      default: ""
    }
  }
};
</script>
